import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { Layout } from './components/Layout';
import HomePage from './pages/Home';
import ShopPage from './pages/Shop';
import ProductDetailPage from './pages/ProductDetail';
import CartPage from './pages/Cart';
import CheckoutPage from './pages/Checkout';
import OrderConfirmedPage from './pages/OrderConfirmed';
import PaymentSuccessPage from './pages/PaymentSuccess';
import PaymentCancelPage from './pages/PaymentCancel';
import QuizPage from './pages/Quiz';
import AboutPage from './pages/About';

function App() {
  return (
    <div className="App">
      <CurrencyProvider>
        <CartProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/product/:slug" element={<ProductDetailPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/order-confirmed" element={<OrderConfirmedPage />} />
                <Route path="/payment/success" element={<PaymentSuccessPage />} />
                <Route path="/payment/cancel" element={<PaymentCancelPage />} />
                <Route path="/quiz" element={<QuizPage />} />
                <Route path="/about" element={<AboutPage />} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </CartProvider>
      </CurrencyProvider>
    </div>
  );
}

export default App;
